import { Navigate, Outlet, useLocation } from "react-router-dom";

interface ProtectedRouteProps {
  allowedRoles?: string[];
}

const ProtectedRoute = ({ allowedRoles }: ProtectedRouteProps) => {
  const location = useLocation();
  
  // Kiểm tra xác thực bằng cách trực tiếp đọc từ localStorage
  const userDataStr = localStorage.getItem("user");
  const userData = userDataStr ? JSON.parse(userDataStr) : null;
  const userRole = userData?.role;
  
  // Kiểm tra xem người dùng đã đăng nhập hay chưa
  if (!userDataStr) {
    // Chuyển hướng đến trang đăng nhập nếu chưa đăng nhập
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }
  
  // Nếu có chỉ định vai trò và người dùng không có vai trò phù hợp
  if (allowedRoles && allowedRoles.length > 0 && (!userRole || !allowedRoles.includes(userRole))) {
    // Chuyển hướng đến trang không có quyền truy cập
    return <Navigate to="/unauthorized" replace />;
  }
  
  // Nếu đã đăng nhập và có quyền thích hợp, hiển thị nội dung
  return <Outlet />;
};

export default ProtectedRoute; 